<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { getHubStores } from '$lib/stores/hubStores';
	import type { Tag } from '$lib/api/restApi';
	import { page } from '$app/stores';
	import { clickOutside } from '$lib/actions/clickOutside';
	import { onMount } from 'svelte';
	import type { Collection } from '$lib/types/Collections';

	export let value: string | null;
	export let isOpen = false;

	const { restApi, hub, collections } = getHubStores();

	const maxSearchLength = 5;
	const hubPrefix = $page.params.hubPrefix;

	let filteredCollections: Collection[] = [];
	let tags: Tag[];
	let filteredTags: Tag[] = [];

	let debounceTimer: ReturnType<typeof setTimeout> | null = null;

	const debounceSearch = (value: string) => {
		if (debounceTimer) {
			clearTimeout(debounceTimer);
		}
		debounceTimer = setTimeout(() => void search(value), 500);
	};

	onMount(async () => {
		let tagsResp = await restApi.fetchTags($hub.id);
		if (tagsResp.data) tags = tagsResp.data;
		isOpen = false; // TODO: This is a hack to get the menu to close on mount. Its flashing open and closed on mount, if the search value is set.
	});

	const search = (value: string) => {
		filteredTags = tags?.filter((tag) => tag.name.includes(value)).slice(0, maxSearchLength) || [];
		filteredCollections =
			$collections
				.filter((collection) => collection.name.includes(value.replace(/^#/, '')))
				.slice(0, maxSearchLength) || [];
	};

	$: if (value) {
		debounceSearch(value);
		isOpen = true;
	}
</script>

{#if isOpen}
	<ul use:clickOutside={() => (isOpen = false)}>
		<li>
			<a href={`/${hubPrefix}/search?q=${value}&app=svelte`} on:click={() => (isOpen = false)}>
				{`"${value}" - ${$_('content.search')}`}
			</a>
		</li>
		{#if filteredCollections.length}
			<li class="header">{$_('common.collections')}</li>
			{#each filteredCollections as collection}
				<li>
					<a href={`/${hubPrefix}/${collection.slug}`} on:click={() => (isOpen = false)}>
						{collection.name}
					</a>
				</li>
			{/each}
		{/if}
		{#if filteredTags.length}
			<li class="header">{$_('hubs.settings.tags')}</li>
			{#each filteredTags as tag}
				<li>
					<a
						href={`/${hubPrefix}/search?q=%23${tag.name}`}
						on:click={() => {
							value = `#${tag.name}`;
							// This needs to be pushed to the end of the event loop, to not be overwritten by the
							// reactive statement that sets isOpen to true on value change
							setTimeout(() => (isOpen = false));
						}}>
						#{tag.name}
					</a>
				</li>
			{/each}
		{/if}
	</ul>
{/if}

<style>
	ul {
		position: absolute;
		inline-size: 350px;
		overflow: auto;
		background: white;
		box-shadow: rgb(0 0 0 / 50%) 1px 1px 6px;
		font-family: var(--presslyFontFamily);
		inset-block-start: 50px;
	}

	li {
		inline-size: 100%;
	}

	a {
		display: block;
		block-size: auto;
		inline-size: 100%;
		padding: 18px;
		padding-block: 18px;
		padding-inline: 9px;
		color: rgb(0 0 0);
		font: inherit;
		text-decoration: none;
	}

	a:hover {
		background-color: rgb(13 142 238);
	}

	.header {
		margin: 0;
		padding-block: 18px;
		padding-inline: 9px;
		background-color: rgb(250 250 250);
		color: rgb(0 0 0);
		text-transform: uppercase;
	}
</style>
